import { CLERK_ERROR_CONFIG } from '@/features/auth/shared/consts/clerk';
import type { AuthError, AuthErrorType } from '@/features/auth/shared/types/auth';
import { extractClerkErrorCode, extractClerkErrorMessage } from '@/features/auth/shared/utils/extractClerkError';
import type { TFunction } from 'i18next';

const getFallbackErrorType = (errorCode: string | null): AuthErrorType => {
  if (errorCode?.includes('password')) return 'password';
  if (errorCode?.includes('email') || errorCode?.includes('identifier')) return 'email';
  if (errorCode?.includes('code')) return 'code';
  return 'general';
};

export const mapClerkError = (error: unknown, t: TFunction): AuthError => {
  const errorCode = extractClerkErrorCode(error);
  const errorConfig = errorCode ? CLERK_ERROR_CONFIG[errorCode] : undefined;

  if (errorConfig) {
    return {
      type: errorConfig.type,
      message: t(errorConfig.messageKey)
    };
  }

  return {
    type: getFallbackErrorType(errorCode ?? null),
    message: extractClerkErrorMessage(error) ?? t('error.login.unknown')
  };
};
